import { useRouter } from "next/navigation";
import { toast } from "react-toastify";
import { UpdateCommunity } from "~/types/CommunityTypes";
import { RouterInputs, api } from "~/utils/api";

import { FormProvider, useForm } from "react-hook-form";
import { FiLink } from "react-icons/fi";
import { Button } from "../../themed/Button";
import { SlugInput } from "../../themed/SlugInput";
import Modal from "../../themed/Modal";

type FormData = RouterInputs["community"]["updateCommunity"];

const EditCommunityURLDialog = ({
    communitySlug,
    isOpen,
    setIsOpen,
}: {
    communitySlug: string;
    isOpen: boolean;
    setIsOpen: () => void;
}) => {
    const router = useRouter();
    const updateCommunity = api.community.updateCommunity.useMutation();

    const methods = useForm<UpdateCommunity>({
        mode: "onChange",
        defaultValues: {
            slug: communitySlug,
        },
    });
    const { register, handleSubmit, formState } = methods;

    const onSubmit = async (data: FormData) => {
        updateCommunity.mutateAsync(
            {
                slug: communitySlug,
                newSlug: data.slug,
            },
            {
                onSuccess: async (res) => {
                    if (res) {
                        toast.dismiss("update-community-loading");
                        toast.success("Community updated successfully.", {
                            autoClose: 1200,
                        });
                        if (res.slug) {
                            router.push(`/${res.slug}`);
                        }
                    }
                },
                onError: (e) => {
                    toast.dismiss("update-community-loading");
                    console.debug("Error", e);
                    toast.error("Something went wrong. Please try again.", {
                        autoClose: 1200,
                    });
                },
            },
        );
    };

    return (
        <Modal
            title="Edit community URL"
            open={isOpen}
            onOpenChange={() => setIsOpen()}
            icon={<FiLink className="border-[#50565E] text-[24px]" />}
            description="This is the URL that people will use to access your community page."
            footer={
                <Button
                    disabled={!formState.isValid || formState.isSubmitting}
                    onClick={handleSubmit(onSubmit)}
                >
                    Save
                </Button>
            }
        >
            <FormProvider {...methods}>
                <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <SlugInput
                            {...register("slug")}
                            name="slug"
                            placeholder="the-grand-slam"
                            className="w-max bg-transparent font-[500]"
                            id="new-community-url"
                            prefixComponent={
                                <div className="text-small">
                                    https://getriver.io/
                                </div>
                            }
                        />
                    </div>
                </div>
            </FormProvider>
        </Modal>
    );
};

export default EditCommunityURLDialog;
